export const ARTICLES_ACCORDION_MODAL = 'articlesAccordionModal'
export const ARTICLES_ACCORDION_MODAL_TITLE = 'Explore Articles'
